import React, { useState } from "react";
import "./TNC.css"; // Change the CSS file name if necessary
import AccordionItem from "./../../components/AccordionItem";

const TNC = () => {
  const [activeSection, setActiveSection] = useState("What is Diamond?");

  const toggleSection = (title) => {
    setActiveSection((prev) => (prev === title ? null : title));
  };

  // Example T&C data, you should modify the content based on your T&C
  const TNC = () => {
    return (
      <div style={{ backgroundColor: "white" }}>
        <div className="tnc-container">
          {/* T&C content converted to JSX */}
          <div className="tnc-introduction">
            <p className="paragraphx">
              You are advised to read this terms and conditions carefully as by
              accessing, viewing or using this website. You (the customer) agree
              to be bound by this Agreement. If you are not agreed to all the
              terms and conditions of this Agreement in their entirety, you
              cannot use this Website and should exit/logout now or you should
              not eligible to use this website.
            </p>
            <p className="paragraphx">
              Reading and accepting the terms of use and reading and accepting
              the provisions of the privacy policy of this website are required
              considerations for the website granting you the right to visit,
              read or interact with it. All persons are denied access to this
              site unless they read and accept the terms of use and the privacy
              policy. This website reserves the right to deny access to any
              person or viewer for any reason. Under the terms of the privacy
              policy, which you accept as a condition for viewing, the website
              is allowed to collect and store data and information for the
              purpose of exclusion and for many other uses. The terms of use
              agreement may change from time to time. Visitors have an
              affirmative duty, as part of the consideration for permission to
              view this website, to keep themselves informed of changes. The
              website and its contents are owned or licensed by the website
              owner. Material contained on the website must be presumed to be
              proprietary and copyrighted. Visitors have no rights whatsoever in
              the site content. Use of website content for any reason is
              unlawful unless it is done with express contract or permission of
              the website.
            </p>
            <p className="paragraphx">
              Disclaimer for contents of site, we have tried our best to provide
              you accurate information but still. The website disclaims any
              responsibility for the accuracy of the content of this website.
              Visitors assume the all risk of viewing, reading, using, or
              relying upon this information. Unless you have otherwise formed an
              express contract to the contrary with the website, you have no
              right to rely on any information contained herein as accurate. The
              website makes no such warranty. By using any information of this
              website nobody can make contract with any other person.
            </p>
            <p className="paragraphx">
              Disclaimer for harm caused to your computer or software from
              interacting with this website or its contents. Visitor assumes all
              risk of viruses, worms, or other corrupting factors. The website
              assumes no responsibility for damage to computers or software of
              the visitor or any person the visitor subsequently communicates
              with from corrupting code or data that is inadvertently passed to
              the visitor's computer. Again, visitor views and interacts with
              this site, or banners or pop-ups or advertising displayed thereon,
              at his own risk.
            </p>
            <p className="paragraphx">
              Disclaimer for harm caused by downloads Visitor downloads
              information from this site at his own risk. Website makes no
              warranty that downloads is free of corrupting computer codes,
              including, but not limited to, viruses and worms. Again, visitor
              views and interacts with this site, or banners or pop-ups or
              advertising displayed thereon, at his own risk.
            </p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div style={{ backgroundColor: "white" }}>
      <div className="tnc2-container">
        <h1 className="tnc2-title">Terms And Conditions</h1>

        <TNC />
        {/* Accordion section for detailed terms */}
        <div className="tnc2-content">
          {tncData.map((section) => (
            <AccordionItem
              key={section.title}
              title={section.title}
              content={section.content}
              isActive={activeSection === section.title}
              onToggle={() => toggleSection(section.title)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TNC;

const tncData = [
  {
    title: "Order Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              In case of non-certified Diamond, you are only placing an order;
              it's not a purchase.
            </p>

            <p className="paragraphxyz">
              Confirmation of the order is subject to the availability of the
              product.
            </p>

            <p className="paragraphxyz">
              Once you have placed an order, it will not be changed but may be
              canceled if shipment has not been done.
            </p>

            <p className="paragraphxyz">
              In case of wire transfer payment, your payment must reach us
              within 5 working days after the order is confirmed by us. We may
              cancel your order in case of payment delay.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Return Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              As our loyal customer, we want you to be satisfied with your
              purchase experience with us. So, we provide a return policy. If,
              for any good reason, you decide not to keep the diamond, we will
              accept it back in its original condition. You must inform us
              within 2 business days from the date of receipt of the diamond and
              return it within 15 business days for a refund from the date of
              receipt. If you fail to follow the above norm, you will not be
              entitled to a refund.
            </p>
            <p className="paragraphxyz">
              Include all original packaging and materials. If your item comes
              with a diamond certificate, you must include the certificate with
              your return, or you may be liable for the cost of certification
              and associated costs.
            </p>

            <p className="paragraphxyz">
              All items being sent back to Pansuriya Impex (HK) Ltd MUST be
              insured. We are not responsible for items lost or damaged while
              shipping. You may use any carrier of your choice to send back your
              item.
            </p>
            <p className="paragraphxyz">
              Our simplified refund process: Once your returned item has been
              inspected by our trained staff, your refund will be promptly
              processed. Please note that items showing signs of wear or those
              that have been altered, engraved, or damaged in any way cannot be
              accepted for return. We will refund the full cost of the item
              EXCLUDING shipping**, handling, and insurance charges. Refunds
              will be made using the mode of payment used in the original
              purchase.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Shipment Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              Product will be shipped strictly to the destination provided and
              approved by the customer. It is the customer's responsibility to
              check and update the shipping and billing information. We will
              follow the information provided for shipping and billing.
            </p>
            <p className="paragraphxyz">
              Shipment will be made immediately after receiving full payment of
              the ordered product.
            </p>

            <p className="paragraphxyz">
              We are liable to pay only the freight and insurance of the shipped
              product up to FOB (Freight On Board). Other applicable taxes,
              duties, etc., are the customer's responsibility.
            </p>
            <p className="paragraphxyz">
              We can ship your purchased product from any of our regional or
              affiliated offices.
            </p>
            <p className="paragraphxyz">
              USD 100 will be levied towards shipping and handling charges per
              invoice amounting below USD 15,000. Invoice amounts above USD
              15,000 are absolutely free of cost. Free shipping is also provided
              to Hong Kong.
            </p>

            <p className="paragraphxyz">
              No shipping charges are applicable if stones are collected
              personally from our affiliated offices.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Conflict Free Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              Pansuriya Impex and its associates are manufacturers and direct
              distributors of high-quality diamonds. We buy rough diamonds from
              legislative sources that comply with UN resolutions. We source
              rough diamonds from reliable sources, and we have a zero tolerance
              policy toward conflict diamonds, which helps prevent illegal
              diamond trade.
            </p>

            <p className="paragraphxyz">
              If any foreign buyer files a suit questioning whether the finished
              polished diamond was manufactured from only KP-certified goods,
              our liability is to prove the authenticity of the diamond through
              documentary evidence. We are not responsible for proving
              authenticity through mine testing.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Price  Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              The price excludes local taxes and duties, if applicable. All
              prices mentioned on the site are in USD.
            </p>

            <p className="paragraphxyz">
              Seldom, there could be human error, system or typographical errors
              in the data uploaded, including prices, and the information may be
              displayed inaccurately. Such errors may occur despite our every
              effort to avoid them. We reserve the right to rectify any and/or
              all such errors when they occur and we do not accept such
              inaccurate or incorrect information, especially pertaining to
              prices.
            </p>
            <p className="paragraphxyz">
              In case a stone's listed price is lower or higher than the actual
              price, we will either contact you for instructions before shipping
              or cancel the order and notify you of such cancellation. This
              decision is at our sole discretion. In such cases, if the product
              is already shipped, the difference between the actual and charged
              price will be paid by the concerned party, or the goods must be
              returned in accordance with business ethics.
            </p>
            <p className="paragraphxyz">
              The prices are subject to change without prior notice.
            </p>
            <p className="paragraphxyz">
              In case of any questions, please feel free to contact our customer
              service manager at net@pansuriyaimpex.com.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Payment Policy",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">We accept only advance payment.</p>
            <p className="paragraphxyz">Yes, we also accept cash payment.</p>

            <p className="paragraphxyz">
              We have a gateway for payment via wire transfer for the time
              being.
            </p>
            <p className="paragraphxyz">
              Payments of all confirmed orders must be paid in advance. Payment
              must be paid in full within 5 working days from the date of
              confirmation of your order.
            </p>

            <p className="paragraphxyz">
              All prices are based on advance payment terms only and prices are
              expressed in USD, unless otherwise stated. Prices will be
              exclusive of any duties, taxes, and/or bank charges.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Policy For Minors",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              Pansuriya Impex does not knowingly collect personal information
              from a person below 18 years of age. If we come to know that we
              have collected personally identifiable information from such a
              person, we will delete that data from our systems.
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Policy  Ammendment",
    content: (
      <div >
        <div className="containerxyz">
          <div className="text-contentxyz">
            <p className="paragraphxyz">
              When you use this website, you agree to Pansuriya Impex's privacy
              policy. This is the entire and exclusive privacy policy, and it
              supersedes any earlier version. We may update this privacy policy
              as and when required or occasionally. When such a revision is
              made, the last update date will be displayed on this page. You are
              encouraged to review the privacy policy periodically to stay
              informed about how we protect your information. Your continued
              usage of this website constitutes your consent to this privacy
              policy and any updates.
            </p>

            <p className="paragraphxyz">
              The Company reserves the right to make any changes to our Terms
              and Conditions and/or our Privacy Policy (which is incorporated
              herein by reference) as we deem necessary or desirable without
              prior notification to you. We suggest that you read our T&C and
              Privacy Policy from time to time in order to stay informed about
              any such changes. If we make changes to our T&C and Privacy Policy
              and you continue to use our site, you are impliedly agreeing to
              the revised T&C and Privacy Policy expressed herein.
            </p>
          </div>
        </div>
      </div>
    ),
  },
];
